import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

import {
  Classes,
  /*Colors, GeneralSubElements,*/ SelectSubElements,
} from "@/types";
import { getBreakpoint, getBreakpointClasses, getCustomMessage } from "@/utils";
import {
  IonCol,
  IonGrid,
  IonRow,
  IonSelect,
  IonSelectOption,
} from "@ionic/vue";
import {
  nextTick,
  onBeforeUnmount,
  onMounted,
  PropType,
  ref,
  watch,
} from "vue";
import { chevronDownOutline } from "ionicons/icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomSelect',
  props: {
  selected_option: [String, Number],
  list: {
    type: Object as PropType<
      {
        id: any;
      }[]
    >,
    required: true,
  },
  label: String,
  aria_label: String,
  placeholder: String,
  getCompleteName: {
    type: Function,
    default: (option: any) => option.id,
  },
  disabled: Boolean,
  no_padding: Boolean,
  //colors: Object as PropType<Colors<GeneralSubElements>>, //<!-- TODO (7): colori
  classes: Object as PropType<Classes<SelectSubElements>>,
},
  emits: ["update:selected_option"],
  setup(__props, { emit }) {

const props = __props;

const updateBreakpoint = () => {
  breakpoint.value = getBreakpoint(window.innerWidth);
};




const breakpoint = ref(getBreakpoint(window.innerWidth));
const selected_option_ref = ref(props.selected_option);

watch(
  () => props.selected_option,
  (value) => {
    selected_option_ref.value = value;
  }
);
watch(
  () => selected_option_ref.value,
  (value) => {
    emit("update:selected_option", value);
  }
);

if (props.classes?.select != undefined || props.classes?.option != undefined) {
  onMounted(() =>
    nextTick(() => {
      window.addEventListener("resize", updateBreakpoint);
    })
  );

  onBeforeUnmount(() => {
    window.removeEventListener("resize", updateBreakpoint);
  });
}

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!

  return (_openBlock(), _createBlock(_unref(IonGrid), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRow), { class: "ion-align-items-center" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), { size: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_ionic_element, {
                element: 
            _unref(getCustomMessage)('select_label', __props.label ?? '', 'string', {
              text: {
                name: 'primary',
                type: 'var',
              },
            })
          
              }, null, 8, ["element"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCol), { sizr: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSelect), {
                value: __props.selected_option,
                "aria-label": __props.label,
                onIonChange: _cache[0] || (_cache[0] = ($event) => (selected_option_ref.value = $event.target.value)),
                justify: "start",
                placeholder: __props.placeholder,
                disabled: __props.disabled,
                interface: "popover",
                "toggle-icon": _unref(chevronDownOutline),
                shape: "round",
                class: _normalizeClass({
            ..._unref(getBreakpointClasses)(__props.classes?.select, breakpoint.value),
            'ion-padding': !__props.no_padding,
          })
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (option) => {
                    return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                      value: option.id,
                      key: option.id,
                      "aria-label": __props.getCompleteName(option),
                      class: _normalizeClass(_unref(getBreakpointClasses)(__props.classes?.option, breakpoint.value))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.getCompleteName(option)), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "aria-label", "class"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "aria-label", "placeholder", "disabled", "toggle-icon", "class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})